import React from 'react'
import globalConfig from 'Helper/configHelpers'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

const withLocation = () => {
  return WrappedComponent => {
    const WithLocation = props => {
      const pathname = useSelector(state => state.router.pathname)
      const dispatch = useDispatch()
      const location = useLocation()
      const navigate = useNavigate()

      React.useEffect(() => {
        globalConfig.setNavigate(navigate)
      }, [])

      React.useEffect(() => {
        if (location.pathname != pathname) {
          dispatch({
            type: 'UPDATE_ROUTER_LOCATION',
            location
          })
        }
      }, [location.pathname])
      return <WrappedComponent {...props} />
    }
    return WithLocation
  }
}

export default withLocation
